import { Badge } from "@mantine/core";
import { IconArchive } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface ArchivedBadgeProps {
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "filled" | "light" | "outline";
}

const ArchivedBadge = ({ size = "sm", variant = "light" }: ArchivedBadgeProps) => {
  const { t } = useTranslation();
  return (
    <Badge
      size={size}
      variant={variant}
      color="gray"
      leftSection={<IconArchive size={12} stroke={2.5} />}
    >
      {t("common.archived", "Archived")}
    </Badge>
  );
};

export default ArchivedBadge;
